/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 ~ Copyright 2018 Adobe Systems Incorporated
 ~
 ~ Licensed under the Apache License, Version 2.0 (the "License");
 ~ you may not use this file except in compliance with the License.
 ~ You may obtain a copy of the License at
 ~
 ~     http://www.apache.org/licenses/LICENSE-2.0
 ~
 ~ Unless required by applicable law or agreed to in writing, software
 ~ distributed under the License is distributed on an "AS IS" BASIS,
 ~ WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 ~ See the License for the specific language governing permissions and
 ~ limitations under the License.
 ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
import React from 'react';
import { Page, withModel } from '@adobe/cq-react-editable-components';
// import utils from "../../utils/utils";
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import loadjs from 'loadjs';

import ErrorBoundary from '../common/ErrorBoundary';
import SessionTimeOut from '../common/SessionModal';

import { getSession, isMVA, setSession, viewport, isBroadBandFlow, isRetailFlow, getAPPID, isVFEligibile } from '../common/Helpers/index';
import { postMessage } from '../common/Helpers/app';
import { apiUrls } from '../../constants/apiUrl';
import { ContentSquareInit } from '../common/Helpers/cs';
import { Polymap } from '../common/Helpers/Polymap';

require('../../assets/fonts/verizon-fonts/fonts.css');
require('./App.css');
require('../../assets/css/layout.scss');
require('../../assets/css/singles.css');

// This component is the application entry point
// const key = "App";
/* eslint class-methods-use-this: ["error", { "exceptMethods": ["componentCleanup"] }] */

class App extends Page {
  constructor(props) {
    super(props);
    if (props.apiServer) {
      if (props?.localStorage === true) {
        window.localStorage.setItem('APIContext', props.apiServer);
      } else {
        setSession('APIContext', props.apiServer);
      }

      // setSession('APIContext', props.apiServer);
    }
    let amAgentLastCachedTime = window.sessionStorage.getItem('amAgentLastCachedTime');
    if (!amAgentLastCachedTime) {
      amAgentLastCachedTime = new Date().getTime();
    }

    const appId = getAPPID();

    window.vzFlags = {
      amAgentLastCachedTime,
      appId: appId || 'NSE',
      isLoggedIn: appId === 'AAL',
      isProd: props.isProd === 'true',
      localStorage: props.localStorage,
      enableVideoCall: props.enableVideoCall,
      getCheckOutDetails: props.getCheckOutDetails || false,
      disableMdnCount: props.disableMdnCount || false,
      isGnavEnabled: props.isGnavEnabled || false,
      isSkipMtnApi: props.isSkipMtnApi || false,
      isNBSSelf: props.isNBSSelf,
      acpTagging: props.acpTagging,
      isWHWISPU: props.isWHWISPU,
      localOfferFlag: props.localOfferFlag,
      excludeIndirect: props.excludeIndirect,
      issetupEdit: props.issetupEdit,
      isNBSProfessional: props.isNBSProfessional,
      registrationTimeoutNonProd: props.registrationTimeoutNonProd || '25000',
      registrationTimeoutProd: props.registrationTimeoutProd || '300000',
      pdcFlag: props.pdcFlag || false,
      fwaModalFlag: props.fwaModalFlag,
      modalFwaTitle: props.modalFwaTitle,
      fwaModalDesktopTimeout: props.fwaModalDesktopTimeout,
      fwaModalMobileTimeout: props.fwaModalMobileTimeout,
      fwaModalMobileImgUrl: props.fwaModalMobileImgUrl,
      fwaModalDesktopImgUrl: props.fwaModalDesktopImgUrl,
      invalidCaseStatusCode: props.invalidCaseStatusCode || '1008,1007,1000',
      msgwithLinkErrorCode: props.msgwithLinkErrorCode || '06, 400,615,701,1000,1008,1023,3000,3002,3504,3606,3607,15501,17104',
      isValidateCartCall: props.isValidateCartCall,
      miniCartApi: props.miniCartApi,
      isLoader: props.isLoader === 'true',
      enableAPFuncComp: props.enableAPFuncComp || false,
      acpIntegrated: props.acpIntegrated,
      vfIntegrated: props.vfIntegrated,
      lqEditAddress: props.lqEditAddress || false,
      isBroadBandFacts: props.isBroadBandFacts,
      nonVzConsent_dark: props.nonVzConsent_dark,
      lteHomePlus: props.lteHomePlus,
      lteHome: props.lteHome,
      fiveGHomePlus: props.fiveGHomePlus,
      fiveGHome: props.fiveGHome,
      isUnitTypeAhead: props.isUnitTypeAhead,
      isOnlyTypeAhead: props.isOnlyTypeAhead,
      useTypeAheadSoeUrl: props.useTypeAheadSoeUrl,
      integratedCartContactInfo: props.integratedCartContactInfo,
      iscontactButtonEnabled: props.iscontactButtonEnabled,
      reqCustAgreeRead: props.reqCustAgreeRead,
      enablePegaProcessStep: props.enablePegaProcessStep,
    };
    window.redirectToHomePage = () => {
      window.sessionStorage.clear();
      window.localStorage.clear();
      setSession('isTransExpiryRetry', 'Y');
      window.location.href = `${apiUrls().redirect5Ghome}?retryFlow=true`;
    };
    window.redirectToPaymentPage = () => {
      setSession('isPaymentFailRetry', 'Y');
      window.location.href = `${apiUrls().redirectPayment}?retryFlow=true`;
    };
    if (getSession('enablePolyMap') === 'Y') {
      loadjs('https://code.jquery.com/jquery-3.6.1.min.js', { returnPromise: true })
        .then(() => {
          Polymap();
        })
        .catch(() => {});
    }
  }

  componentCleanup() {
    if (window?.vzFlags?.localStorage) {
      localStorage.clear();
    }
    sessionStorage.clear();
  }

  componentWillUnmount() {
    this.componentCleanup();
    window.removeEventListener('beforeunload', this.componentCleanup);
  }

  // navigatePage = (pageName) => {
  //   this.props.history.push({
  //     pathname: pageName,
  //     search: window.location.search ? window.location.search : '',
  //   });
  // }

  showFabIcon = () => {
    const msg = {
      actionType: 'updateChatFab',
      chatFab: {
        hideFabOverlay: true,
        shouldExpandFab: true,
      },
    };
    postMessage(msg);
  };

  render() {
    if (window && (window.vzwDL === undefined || window.vzwDL === null)) {
      window.vzwDL = {};
    }

    let sessionTimeOutJSON = {};
    sessionTimeOutJSON = {
      timeout: this.props.sessionTimeoutTime || '15',
      warning: this.props.sessionTimeoutWarningTime || '12',
      newSessionTimer: this.props.newSessionTimer || false,
      amAgentLastCachedTime: window.vzFlags.amAgentLastCachedTime,
      continueSessionURL: window.location.href,
      ctxText: 'Back to 5G Home',
      guestContinueSessionURL: window.location.href,
      landingPageUrl: isVFEligibile() ? '/discounts/verizon-forward/' : '/5g/home/?es=y', //  es means expiredsession
    };

    this.showFabIcon();

    const type = viewport();
    let classValue = '';
    if (type === 'mobile') {
      classValue = 'iteMobile foo-content-container-min-height';
    } else if (type === 'tablet') {
      classValue = 'tabletDevice foo-content-container-min-height';
    } else if (type === 'desktop') {
      classValue = 'foo-content-container-min-height';
    }
    classValue += ` ${!isBroadBandFlow() && !isRetailFlow() ? 'vzAMContainer' : ''} ${isMVA() ? 'mvaDevice' : ''}`;

    return (
      <ErrorBoundary>
        <div className={classValue} role="main">
          <ContentSquareInit />
          {/* <PageHeader/> */}
          {this.childComponents}
          {this.childPages}
          {type !== 'mfapp' && sessionTimeOutJSON && Object.keys(sessionTimeOutJSON).length > 0 && (
            <SessionTimeOut {...sessionTimeOutJSON} sessionExtension={this.props.sessionExtension} />
          )}

          {/* <Loader active={this.props.loaderStatus} fullscreen={false} /> */}
          {/* <PageFooter/> */}
        </div>
      </ErrorBoundary>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { preLoadServices, completedRequests } = state.loader || {};
  const { asyncRequestWatcher } = ownProps;
  let preLoadServiceCompleted = true;
  if (asyncRequestWatcher && preLoadServices?.length) {
    const completedRequestKeys = Object.keys(completedRequests || {}).filter((requestKey) => completedRequests[requestKey]);
    preLoadServiceCompleted = preLoadServices.every((preLoadRequest) => completedRequestKeys.includes(preLoadRequest));
  }
  return {
    loaderStatus: (state && state.loader && state.loader.loaderStatus) || !preLoadServiceCompleted,
    sessionExtension: state?.sessionExtension,
  };
};

const mapDispatchToProps = {
  // fetchURL
};
// const withReducer = compose(
//   injectReducer({ key: 'sessionExtension', reducer: sessionExtension }),
// );

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);
// const withSaga = injectSaga({ key, saga });
export default compose(
  withModel,
  withConnect,
  withRouter,
)(App);
